// extracted by mini-css-extract-plugin
export default {"title":"BludataBluTitle_title__wWYkt"};